import { TABS, TabValues } from "../../constants/tabs.constant";

export const findTab = (pathname: string): TabValues | undefined => {
  const tab = TABS[TABS.findIndex(({ url }) => url === pathname)]?.value;

  return tab;
};
